// extracted by mini-css-extract-plugin
export default {"socialLinks":"SocialLinks_socialLinks__1Btcv","iconBox":"SocialLinks_iconBox__MeP-a"};